import { Maybe } from 'types/Maybe'

type ChatContent = { type: 'text'; text: string } | {
  type: 'file'
  file: {
    name: string
    mime: string
    data: string
  }
} | {
  type: 'image_url'
  image_url: {
    url: string
  }
}

enum ChatEventType {
  STARTED = 'STARTED',
  CONTENT_DELTA = 'CONTENT_DELTA',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}

interface ChatStreamEvent {
  type: ChatEventType
  content: Maybe<string>
  chatId: Maybe<string>
}

interface ChatStreamHandlers {
  onStarted: (chatId: string) => void
  onContent: (content: string) => void
}

interface SendChatMessageVariables extends ChatStreamHandlers {
  chatId?: string
  content: ChatContent[]
  companyId?: number
  signal: AbortSignal
}

class ChatApiError extends Error {
  readonly status: number

  constructor(status: number) {
    super('Chat request failed')
    this.name = 'ChatApiError'
    this.status = status
    Object.setPrototypeOf(this, ChatApiError.prototype)
  }
}

type ChatSendErrorCode =
  | 'NOT_CONFIGURED'
  | 'UNAUTHENTICATED'
  | 'NOT_FOUND'
  | 'COMPANY_UNAVAILABLE'
  | 'STREAM_ERROR'
  | 'UNCONFIRMED'

interface ChatStreamDependencies {
  fetch: typeof window.fetch
  getAccessToken: () => Maybe<string>
  refresh: () => Promise<void>
}

interface EditChatVariables {
  id: string
  title: string
}

interface DeleteChatVariables {
  id: string
}

export type {
  ChatContent,
  ChatStreamEvent,
  ChatStreamHandlers,
  SendChatMessageVariables,
  ChatSendErrorCode,
  ChatStreamDependencies,
  EditChatVariables,
  DeleteChatVariables,
}

export { ChatEventType, ChatApiError }
